import { QAState } from '@/store/qa/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<QAState> = {};
